import React from 'react';

import Title from './Title';

const HeadingElement = ({
  ariaId = '',
  headingLevel,
  children,
  className = '',
  style,
  hasWrapper = false,
}) => {
  const attributes = ariaId ? { id: ariaId, className } : { className };
  if (hasWrapper && headingLevel === 1) {
    return <Title {...attributes} title={children} style />;
  }
  if (headingLevel === 1) {
    return (
      <h1 {...attributes} style={style}>
        {children}
      </h1>
    );
  }
  if (headingLevel === 2) {
    return (
      <h2 {...attributes} style={style}>
        {children}
      </h2>
    );
  }
  if (headingLevel === 3) {
    return (
      <h3 {...attributes} style={style}>
        {children}
      </h3>
    );
  }
  if (headingLevel === 4) {
    return (
      <h4 {...attributes} style={style}>
        {children}
      </h4>
    );
  }
  if (headingLevel === 5) {
    return (
      <h5 {...attributes} style={style}>
        {children}
      </h5>
    );
  }
  return (
    <h6 {...attributes} style={style}>
      {children}
    </h6>
  );
};

export default HeadingElement;
